import { eur, num, NA } from "@/lib/format";

const BASIS_LABEL = {
  CO2: "CO₂-tarief",
  CO2_PLUS_LIST: "CO₂ + catalogusprijs",
  LIST: "Catalogusprijs",
};

export const TariffVariants = ({ bpm }) => {
  const variants = bpm?.variants || [];
  if (!variants.length) return null;
  const chosen = bpm?.chosen_variant_key;
  const usable = variants.filter((v) => v.computable);

  return (
    <div className="border border-slate-200" data-testid="bpm-tariff-variants">
      <div className="flex items-center justify-between border-b border-slate-200 bg-slate-100 px-3 py-1.5">
        <span className="label-xs">Toegestane historische tarieven ({usable.length}/{variants.length} te berekenen)</span>
        {bpm?.tariff_saving > 0 && (
          <span className="chip border-emerald-300 bg-emerald-50 text-emerald-800" data-testid="bpm-tariff-saving">
            {eur(bpm.tariff_saving)} lager dan huidig tarief
          </span>
        )}
      </div>
      <div className="max-h-[280px] overflow-y-auto">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tariefperiode</th>
              <th>Grondslag</th>
              <th>CO₂-norm</th>
              <th className="text-right">Bruto BPM</th>
              <th className="text-right">Te betalen</th>
            </tr>
          </thead>
          <tbody>
            {variants.map((v) => {
              const isChosen = v.period_key === chosen;
              return (
                <tr
                  key={v.period_key}
                  data-testid={`bpm-variant-${v.period_key}`}
                  className={isChosen ? "bg-emerald-50" : v.computable ? "" : "text-slate-400"}
                >
                  <td className="text-[11.5px]">
                    <span className={isChosen ? "font-semibold text-emerald-800" : ""}>
                      {v.period_label}
                    </span>
                    {isChosen && (
                      <span className="ml-1 chip border-emerald-300 bg-white text-emerald-800">
                        gekozen
                      </span>
                    )}
                    {!v.computable && (
                      <div className="text-[10px] leading-tight text-amber-700">
                        Niet te berekenen: {(v.missing || []).join(", ")}
                      </div>
                    )}
                  </td>
                  <td className="text-[11px]">{BASIS_LABEL[v.basis] || v.basis}</td>
                  <td className="text-[11px]">{v.tariff_co2_method}</td>
                  <td className="num">{v.gross_bpm === null ? NA : eur(v.gross_bpm)}</td>
                  <td className={`num ${isChosen ? "font-semibold text-emerald-800" : ""}`}>
                    {v.payable_bpm === null ? NA : eur(v.payable_bpm)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="px-3 py-2 text-[10.5px] leading-snug text-slate-500">
        Bij een gebruikte import mag het laagste bpm-tarief tussen ingebruikname en RDW-goedkeuring
        worden gebruikt, met de regels die in die periode golden (Belastingdienst, tarievenlijst vanaf
        1993). Alle regels van de gekozen periode zijn hieronder verwerkt.
      </p>
      {(bpm?.components || []).length > 0 && (
        <div className="border-t border-slate-200">
          <div className="label-xs border-b border-slate-200 bg-slate-50 px-3 py-1.5">
            Opbouw bruto BPM — {bpm?.tariff_period?.label}
          </div>
          {bpm.components.map((c) => (
            <div
              key={`${c.label}-${c.amount}`}
              className="flex items-start justify-between gap-3 border-b border-slate-100 px-3 py-1"
            >
              <span className="text-[11.5px] text-slate-700">{c.label}</span>
              <span className="mono shrink-0 text-[11.5px] text-slate-800">{eur(c.amount)}</span>
            </div>
          ))}
          <div className="flex items-center justify-between bg-slate-50 px-3 py-1.5">
            <span className="text-[12px] font-semibold text-slate-900">Bruto historische BPM</span>
            <span className="mono text-[12px] font-semibold text-slate-900">
              {eur(bpm.gross_historical_bpm)}
            </span>
          </div>
        </div>
      )}
      {bpm?.co2_used !== null && bpm?.co2_used !== undefined && (
        <div className="px-3 py-1.5 text-[10.5px] text-slate-500">
          Gebruikte CO₂ in dit tarief: {num(bpm.co2_used)} g/km ({bpm.co2_measurement_method})
        </div>
      )}
    </div>
  );
};

export default TariffVariants;
